import { Request } from 'fetchboi'

export const sendContact = Request.register({
    endpoint: '/businessMessages',
    method: 'post',
})